/* unplugin-vue-components disabled */import script from "./NewUpdateInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./NewUpdateInformation.vue?vue&type=script&setup=true&lang=js"

import "./NewUpdateInformation.vue?vue&type=style&index=0&id=52db8d0e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52db8d0e"]])

export default __exports__